<template>
  <div class="hotel-card" @click="view(hData)">
    <div class="card-image-wrap">
      <img :src="hData.HotelPicture">
      <div class="card-image-overlay"></div>
      <div class="card-cancellation" v-if="hData.free_cancellation">
        <i class="fas fa-check fa-fw"></i>
        Free Cancel
      </div>
    </div>
    <div class="card-body">
      <!-- <div class="card-categories">
        <span class="cat-tag" v-for="tag in hData.HotelAmenities.slice(0, 3)" :title="tag">{{ tag }}</span>
        <span class="cat-tag" v-if="hData.HotelAmenities.length > 3">...</span>
      </div> -->
      <h3 class="card-title">{{ hData.HotelName }}</h3>
      <p class="card-desc">{{ cleanTags(hData.HotelAddress) }}</p>
      <div class="card-rating" v-if="hData.StarRating">
        <i class="fas fa-star fa-fw"></i>
        {{ hData.StarRating }}
      </div>
      <div class="card-footer">
        <div class="card-price">
          <span class="currency">{{ currencySymbol[currency.code] }}</span>
          <span class="amount">{{ applyCurrency(hData.Price, false) }}</span>
          <span class="per">/night</span>
        </div>
        <button class="card-btn">View Details</button>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'

export default {
  props: ['hData'],
  data () {
    return {
      currencySymbol: currencySymbol
    }
  },
  computed: {
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    view (x) {
      let self = this
      this.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dAPI}/hotel/details`, {
        HotelCode: x.HotelCode,
        ResultToken: x.ResultToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('hotel/setData', {
          selected: x,
          view: r.HotelInfoResult.HotelDetails
        })
        self.$router.push('hotel/view')
      })
    },
    cleanTags (x) {
      let parser = new DOMParser()
      return parser.parseFromString(x, 'text/html').body.textContent.slice(0, 200)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.PublishedPrice
      if (data.Currency !== 'USD' && this.currency.code !== data.CurrencyCode) {
        x = x / this.currency.list[data.CurrencyCode]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    }
  }
}
</script>

<style lang="scss" scoped>
.hotel-card{
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(236, 174, 32, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
  display: flex;
  cursor: pointer;

  &:hover{
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.08), 0 0 0 1px rgba(236,174,32,0.15);

    .card-image-wrap img {
      transform: scale(1.05);
    }
  }
}
.card-image-wrap {
  position: relative;
  max-height: 300px;
  width: 300px;
  overflow: hidden;

  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }
}
.card-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.5) 0%, transparent 60%);
}
.card-cancellation {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(34, 197, 94, 0.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 20px;
}
.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.card-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.cat-tag {
  font-size: 11px;
  font-weight: 600;
  color: #ECAE20;
  background: rgba(243, 191, 73, .22);
  padding: 3px 10px;
  border-radius: 20px;
  letter-spacing: .6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90px;
}
.card-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 10px !important;
  line-height: 1.3;
}
.card-desc {
  font-size: 13.5px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 16px !important;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-rating{
  padding: 0 0 5px;
  font-weight: 600;
  i{
    color: #f1d826;
    margin-right: 3px;
  }
}
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid #f1f3f6;
}
.card-price {
  display: flex;
  align-items: baseline;
  gap: 4px;

  .currency {
    font-size: 13px;
    font-weight: 600;
    color: #8892a0;
  }
  .amount {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .per {
    font-size: 12px;
    color: #b0b8c4;
  }
}
.card-btn {
  padding: 10px 22px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

@media only screen and (max-width: 641px) {
  .hotel-card{
    flex-direction: column;
  }
  .card-image-wrap {
    height: 200px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// hotel-card.vue?e8825324